import { AppsData } from "data/AppsData";
import { StorageService } from "./StorageService";
export class RecentGamesService {
  static MAX_LENGTH = 5;

  static addGame(gameId, time) {
    const game = { gameId, time };
    const gamesStr = StorageService.getRecentlyPlayedGames();
    let games = gamesStr || [];
    games = games.filter(g => g.gameId !== gameId);
    games.unshift(game);
    if (games.length >= RecentGamesService.MAX_LENGTH) {
      games.pop();
    }
    StorageService.setRecentlyPlayedGames(JSON.stringify(games));
  }

  static getGames() {
    const gamesStr = StorageService.getRecentlyPlayedGames();
    if (gamesStr) {
      try {
        const list = [];
        const gameList = gamesStr;
        gameList.forEach(({ gameId, time }) => {
          const game = AppsData.find(game => game.game_id === gameId);
          if (game) {
            list.push({ ...game, gameId, time });
          }
        });
        return list;
      } catch (error) {
        console.error(
          "Error parsing recently played games from local storage:",
          error
        );
      }
    }
    return [];
  }
}
